import LoyaltyTier from '@components/loyaltyTier/LoyaltyTier'
import Page from '@components/Page/Page'
import { Permission } from '@utils/permissions'
import { Card, Col, Space, Typography } from 'antd'

const { Title, Text } = Typography

const LoyaltyTiersPage = () => {
  return (
    <Page
      permissions={Permission.listLoyaltyTier}
      pageTitle={{
        title: 'Loyalty tiers',
        level: 4,
      }}
      noWrapWithCol
    >
      <LoyaltyTier.CardList />
      <Col span={24}>
        <Card style={{ borderStyle: 'dashed' }}>
          <Space orientation="vertical">
            <Space className="w-full space-between">
              <Title className="m-0" level={5}>
                Default
              </Title>
            </Space>
            <Text type="secondary">
              All other people outside a Loyalty Tier will be considered inside
              default tier
            </Text>
          </Space>
        </Card>
      </Col>
    </Page>
  )
}

export default LoyaltyTiersPage
